import { APIInvoice, Invoice } from "../types/invoices";

export const mapAPIInvoiceToInvoice = (apiInvoice: APIInvoice): Invoice => {
  return {
    id: apiInvoice.id,
    externalInvoiceId: apiInvoice.external_invoice_id,
    invoiceId: apiInvoice.invoice_id,
    signatureDate: apiInvoice.signature_date,
  };
};
